export type ReportModuleCategory = 'purchasing' | 'sales' | 'finance' | 'operations';

export type ReportModuleDef = {
  slug: string;
  label: string;
  icon: string;
  title: string;
  description: string;
  category: ReportModuleCategory;
};

export const REPORT_MODULE_CATEGORIES: {
  id: ReportModuleCategory;
  label: string;
}[] = [
  { id: 'purchasing', label: 'Purchasing' },
  { id: 'sales', label: 'Sales' },
  { id: 'finance', label: 'Finance' },
  { id: 'operations', label: 'Operations' },
];

export const REPORT_MODULES: ReportModuleDef[] = [
  {
    slug: 'item-analysis',
    label: 'Item Analysis',
    icon: '📦',
    title: 'Customise Items Analysis & Review',
    description: 'Customer × item stock, BPO, shipments and monthly usage.',
    category: 'purchasing',
  },
  {
    slug: 'storage-billing',
    label: 'Storage Billing',
    icon: '🏬',
    title: 'Storage Billing Report',
    description: 'ICRE stock families, free-storage status, GRNs newest→oldest.',
    category: 'purchasing',
  },
];

export const REPORT_DEFAULT_SLUG = 'item-analysis';

export function reportModulesByCategory(category: ReportModuleCategory): ReportModuleDef[] {
  return REPORT_MODULES.filter((mod) => mod.category === category);
}
